import { supabase } from '../config/supabaseConfig.ts';

export const modelPricingService = {
  // Precio vigente de cada modelo (valid_to IS NULL)
  getCurrent: async () => {
    const { data, error } = await supabase
      .from('model_pricing')
      .select('*')
      .is('valid_to', null)
      .order('model');
    if (error) throw error;
    return data || [];
  },

  // Histórico completo de un modelo, más reciente primero
  getHistory: async (model) => {
    const { data, error } = await supabase
      .from('model_pricing')
      .select('*')
      .eq('model', model)
      .order('valid_from', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  // Da de alta un precio nuevo. El trigger de Postgres cierra automáticamente
  // el precio vigente anterior de ese modelo (valid_to = valid_from del nuevo).
  addPrice: async ({ model, price_per_1m_prompt, price_per_1m_completion }) => {
    const { data, error } = await supabase
      .from('model_pricing')
      .insert({
        model,
        price_per_1m_prompt,
        price_per_1m_completion,
      })
      .select()
      .single();
    if (error) throw error;
    return data;
  },
};
